// O back devolve um `message` genérico ("Houve um erro ao criar o cupom.") e o
// motivo real em `detail_error` (lista de erros do model). Mostrar o motivo.
export const couponErrorMessage = (err: any, fallback: string): string => {
  const data = err?.response?.data
  const detail = data?.detail_error

  if (Array.isArray(detail) && detail.length > 0) return detail.join('. ')
  if (typeof detail === 'string' && detail.trim() && data?.error) {
    // detail_error string vem de exceção não tratada (stack/SQL): não expor.
    return data?.message || fallback
  }

  return data?.message || fallback
}
